import { httpClient } from "./API";
import {
  SearchEvCarNoopEventsCondition,
  EvCarNoopEvents,
  EvCarNoopEventsEditRequest,
} from "@/models/carUnderuseEvents";
import {
  CarUnderuseEvent,
  SearchCarUnderuseEventCondition,
  CarUnderuseAnswersEditRequest,
} from "@/models/carUnderuseEvents/underuse";
import {
  CarUnderuseAnswer,
  SearchCarUnderuseAnswerCondition,
} from "@/models/carUnderuseEvents/answers";
import { RecordCount } from "@/models/common";
import { AxiosResponse } from "axios";
import qs from "qs";

export const getCarNoopEventsAPI = async (
  condition: SearchEvCarNoopEventsCondition,
  page: number,
  size: number
): Promise<AxiosResponse<EvCarNoopEvents[]>> => {

  return httpClient.get("core/internal/calgary/evCarUnderuseEvents/", {
    params: { ...condition, page, size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const countCarNoopEventsAPI = async (
  condition: SearchEvCarNoopEventsCondition
): Promise<AxiosResponse<RecordCount>> => {

  return httpClient.get("core/internal/calgary/evCarUnderuseEvents/count", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getCarNoopEventAPI = async (
  id: number,
): Promise<AxiosResponse<EvCarNoopEvents>> => {
  return httpClient.get(`core/internal/calgary/evCarUnderuseEvents/${id}`);
};

export const editCarNoopEventsAPI = async (
  id: number,
  request: EvCarNoopEventsEditRequest
): Promise<AxiosResponse<EvCarNoopEvents>> => {
  return httpClient.put(`core/internal/calgary/evCarUnderuseEvents/${id}`, request);
};

export const getCarUnderuseEventsAPI = async (
  condition: SearchCarUnderuseEventCondition,
  page: number = 0,
  size: number = 30
): Promise<AxiosResponse<CarUnderuseEvent[]>> => {
  return httpClient.get("core/internal/calgary/evCarUsageEvents/underuse", {
    params: { ...condition, page, size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const countCarUnderuseEventsAPI = async (
  condition: SearchCarUnderuseEventCondition,
): Promise<AxiosResponse<RecordCount>> => {
  return httpClient.get("core/internal/calgary/evCarUsageEvents/underuse/count", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getCarUnderuseEventAPI = async (
  id: number,
  yearMonth: string
): Promise<AxiosResponse<CarUnderuseEvent>> => {
  return httpClient.get(`core/internal/calgary/evCarUsageEvents/underuse/${id}`,
    { params: { yearMonth } }
  );
};

export const editCarUnderuseAnswersAPI = async (
  id: number,
  yearMonth: string,
  request: CarUnderuseAnswersEditRequest
): Promise<AxiosResponse<CarUnderuseEvent>> => {
  return httpClient.put(`core/internal/calgary/evCarUsageEvents/underuse/${id}/${yearMonth}/answers`,
    request);
};

export const getCarNoopReasonedEventsAPI = async (
  condition: SearchEvCarNoopEventsCondition,
  page: number,
  size: number
): Promise<AxiosResponse<EvCarNoopEvents[]>> => {
  return httpClient.get("core/internal/calgary/evCarUnderuseEvents/reasoned", {
    params: { ...condition, page, size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const countCarNoopReasonedEventsAPI = async (
  condition: SearchEvCarNoopEventsCondition
): Promise<AxiosResponse<RecordCount>> => {
  return httpClient.get("core/internal/calgary/evCarUnderuseEvents/reasoned/count", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getCarUnderuseAnswersAPI = async (
  condition: SearchCarUnderuseAnswerCondition,
  page: number,
  size: number
): Promise<AxiosResponse<CarUnderuseAnswer[]>> => {
  return httpClient.get("core/internal/calgary/evCarUnderuseMonthlyAnswers/", {
    params: { ...condition, page, size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const countCarUnderuseAnswersAPI = async (
  condition: SearchCarUnderuseAnswerCondition
): Promise<AxiosResponse<RecordCount>> => {
  return httpClient.get("core/internal/calgary/evCarUnderuseMonthlyAnswers/count", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};
